import { useMutation } from '@tanstack/react-query';
import { generateStatement } from '../requests';
import type { GenerateStatementFormValues } from '../../model';
import type { OperationFilter } from '@/shared/types';

type Props = {
  filter: OperationFilter;
};

export function useGenerateStatement({ filter }: Props) {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: GenerateStatementFormValues) =>
      generateStatement(filter, data),
  });

  return {
    generateStatement: mutateAsync,
    isPending,
  };
}
